// extracted by mini-css-extract-plugin
module.exports = {"normal":"normal___3AbSb","title":"title___MhkPP"};